import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import { shouldUseAGGActivityV3 } from '../shouldUseAGGActivityV3.ts';

import HomeRecentWorkQuery from './__generated__/HomeRecentWorkQuery.graphql.ts';
import type {
	RecentListHomeRecentWorkV3Query as RecentListHomeRecentWorkV3Query$data,
	RecentListHomeRecentWorkV3QueryVariables as RecentListHomeRecentWorkV3Query$variables,
	RecentListHomeRecentWorkV3Query_Query,
} from './__types__/RecentListHomeRecentWorkV3Query.ts';
import { getRecentWorkQueryOptions } from './recentWorkQueryHelpers.ts';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

export const useHomeRecentWorkData = ({
	isWhiteboardViewedEnabled,
	isDatabaseEnabled,
	isSlidesEnabled,
	first,
}: {
	isWhiteboardViewedEnabled: boolean;
	isDatabaseEnabled: boolean;
	isSlidesEnabled?: boolean;
	first?: number;
}): {
	data: RecentListHomeRecentWorkV3Query_Query | undefined;
	loading: boolean;
	error: ApolloErrorInterop | undefined;
} => {
	const { cloudId, isLoggedIn } = useSessionData();
	const { data, loading, error } = useQueryInterop<
		RecentListHomeRecentWorkV3Query$data,
		RecentListHomeRecentWorkV3Query$variables
	>(HomeRecentWorkQuery, {
		...getRecentWorkQueryOptions({
			cloudId,
			isLoggedIn,
			isWhiteboardViewedEnabled,
			isDatabaseEnabled,
			isSlidesEnabled,
			first,
		}),
		...(shouldUseAGGActivityV3() && { interopApolloAggClient: true }),
	});

	return { data, loading, error };
};
